const AUTH_STORAGE_PREFIXES = ['CognitoIdentityServiceProvider', 'amplify-']
const AUTH_STORAGE_SUBSTRINGS = ['oauth', 'federated']

export const APP_BUILD_STORAGE_KEY = 'app-build-id'

const shouldRemoveStorageKey = (key: string) => {
  if (key === 'auth') return true

  return (
    AUTH_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix)) ||
    AUTH_STORAGE_SUBSTRINGS.some((fragment) =>
      key.toLowerCase().includes(fragment)
    )
  )
}

const clearMatchingStorage = (storage: Storage) => {
  const keysToRemove: string[] = []

  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index)
    if (!key) continue

    if (shouldRemoveStorageKey(key)) {
      keysToRemove.push(key)
    }
  }

  keysToRemove.forEach((key) => storage.removeItem(key))
}

export const clearAuthSession = () => {
  clearMatchingStorage(window.localStorage)
  clearMatchingStorage(window.sessionStorage)
}
